var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 60,
    viewBox: "0 0 51 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5110_2670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 13.6533C19.3637 13.5604 19.3334 13.5294 19.6365 13.4985C20.2122 13.4056 21.5456 13.5294 22.485 13.7462C24.6668 14.2725 26.6365 15.6347 28.7274 18.0186L29.2728 18.6688L30.0607 18.5449C33.4243 17.9877 36.8789 18.4211 39.7577 19.7833C40.5456 20.1548 41.788 20.8979 41.9395 21.0836C42.0001 21.1455 42.091 21.548 42.1516 21.9505C42.3637 23.4056 42.2728 24.4892 41.8183 25.3251C41.5759 25.7895 41.5759 25.9133 41.7274 26.3158C41.8486 26.6254 42.2122 26.8421 42.5456 26.8421C43.2728 26.8421 44.0304 25.6657 44.394 24.0248L44.5456 23.3746L44.8183 23.6842C46.3637 25.4489 47.5759 27.8948 47.7577 29.6285L47.8183 30.0929L47.5456 29.6904C47.091 28.9784 46.6668 28.514 46.091 28.1115C45.0607 27.3994 43.9698 27.1827 41.091 27.0279C38.485 26.8731 37.0001 26.6564 35.5456 26.161C33.0607 25.3251 31.788 24.2415 28.8486 20.2477C27.5456 18.483 26.7274 17.5233 25.9092 16.7183C24.1213 14.9536 22.3334 14.0248 20.0001 13.6533Z",
    fill: "url(#paint0_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5761 17.5853C42.6367 16.4089 42.7882 15.6349 43.1215 14.9228C43.2427 14.6442 43.3639 14.3965 43.3943 14.3965C43.4246 14.3965 43.364 14.6132 43.273 14.8609C43.0306 15.542 43.0003 16.5017 43.1518 17.5853C43.3639 18.9785 43.4549 19.1643 44.9094 20.6813C45.5761 21.3934 46.3639 22.2912 46.667 22.6627L47.1821 23.3439L46.667 22.8485C46.0306 22.2293 44.5761 21.0528 44.2427 20.898C44.0306 20.7742 44.0003 20.7742 43.8488 20.929C43.7276 21.0528 43.6973 21.2386 43.6973 22.1364C43.667 23.5296 43.4852 24.3965 43.0306 25.2943C42.7882 25.7587 42.7579 25.6658 42.97 25.1395C43.1215 24.737 43.1518 24.5513 43.1518 23.22C43.1518 20.5265 42.8488 19.8764 41.0003 18.7928C40.5458 18.5141 39.7579 18.1117 39.3033 17.8949C38.8185 17.6782 38.4549 17.4925 38.4852 17.4925C38.5458 17.4305 40.3336 17.9569 41.0306 18.2665C42.0912 18.6999 42.273 18.7309 42.3943 18.6999C42.4852 18.607 42.5458 18.3593 42.5761 17.5853Z",
    fill: "url(#paint1_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2429 22.1981C19.9702 20.4024 19.152 17.6161 19.3338 15.5418L19.3944 14.8916L19.6974 14.9535C20.2429 15.0464 21.1823 15.4179 21.6368 15.6966C22.849 16.4396 23.3944 17.4613 23.9096 20C24.0611 20.743 24.2732 21.6099 24.3641 21.8885C24.5156 22.3529 25.0914 23.4365 25.5762 24.1176C25.9096 24.613 25.6975 24.8606 24.9399 24.7987C23.7884 24.6749 22.2429 23.5913 21.2429 22.1981Z",
    fill: "url(#paint2_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0304 35.6657C35.0304 33.189 32.9092 31.0527 32.9092 27.4305C32.9092 26.9041 32.9395 26.4707 32.9395 26.4707C32.9698 26.4707 33.1819 26.6565 33.4546 26.8732C34.6668 27.8639 36.0304 28.2973 39.8183 28.8546C42.0304 29.1952 43.3031 29.4428 44.4546 29.8453C48.1213 31.0837 50.394 33.6224 50.9395 37.0589C51.091 38.0496 51.0001 39.9382 50.7577 40.9289C50.5455 41.7029 49.9395 43.127 49.788 43.158C49.7577 43.158 49.6971 43.0032 49.6971 42.7555C49.6365 41.4552 49.0001 40.2168 47.9395 39.2571C46.6668 38.1425 45.0304 37.3066 41.0304 35.6657Z",
    fill: "url(#paint3_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7878 36.6871C36.7272 36.2227 36.5757 35.6344 36.4848 35.3868L36.3333 34.9224L36.606 35.2629C36.9999 35.7273 37.303 36.2846 37.5757 37.0586C37.7878 37.6468 37.7878 37.8326 37.7878 38.7923C37.7878 39.7211 37.7575 39.9378 37.5757 40.4642C37.2727 41.3001 36.909 41.8883 36.303 42.5385C35.2121 43.684 33.7878 44.3032 31.7575 44.5818C31.3939 44.6128 30.3636 44.7056 29.4545 44.7676C27.1818 44.8914 25.6666 45.1391 24.303 45.6344C24.1212 45.6964 23.9393 45.7583 23.909 45.7273C23.8484 45.6654 24.7878 45.1081 25.5454 44.7366C26.606 44.2103 27.6969 43.9317 30.0909 43.4982C31.2727 43.3125 32.4848 43.0648 32.7878 42.9409C35.7878 41.9812 37.2727 39.5973 36.7878 36.6871Z",
    fill: "url(#paint4_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5455 41.6718C38.7576 39.9071 38.5758 38.2352 39.0001 36.6563C39.0607 36.5015 39.1213 36.3467 39.1819 36.3467C39.2425 36.3467 39.4243 36.4396 39.6061 36.5634C39.9698 36.8111 40.7273 37.2445 42.6667 38.3281C45.1213 39.6903 46.5152 40.743 47.4849 41.9504C48.3334 43.003 48.8486 44.2105 49.091 45.6965C49.2425 46.5324 49.1516 48.5448 48.9395 49.3807C48.2728 52.0123 46.7576 54.1176 44.5455 55.325C44.2122 55.5108 43.9395 55.6346 43.9092 55.6346C43.8789 55.6346 44.0001 55.325 44.1819 54.9535C44.9092 53.3745 45.0001 51.8575 44.4546 50.1547C44.1213 49.1021 43.4243 47.8327 42.0304 45.6965C40.3637 43.2197 39.9698 42.5696 39.5455 41.6718Z",
    fill: "url(#paint5_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9694 51.1456C19.2118 49.2261 21.9694 47.8638 24.5148 47.4304C25.6057 47.2446 27.4239 47.3066 28.4239 47.5852C30.03 48.0186 31.4845 48.9474 32.2421 50.0929C32.9694 51.2075 33.3027 52.1672 33.636 54.3035C33.7572 55.1394 33.9088 56.0063 33.9391 56.192C34.1815 57.3066 34.6663 58.1734 35.2724 58.6378C36.2118 59.3499 37.8482 59.3809 39.4542 58.7617C39.7269 58.6688 39.9694 58.5759 39.9694 58.6069C40.03 58.6688 39.2118 59.2261 38.6663 59.5047C37.9088 59.9072 37.3027 60.031 36.4845 60.031C35.03 60.031 33.7875 59.257 32.7875 57.709C32.5754 57.3994 32.1512 56.5016 31.7876 55.6657C30.7269 53.158 30.1815 52.4149 28.9391 51.579C27.8482 50.8669 26.4542 50.7121 25.3936 51.2385C23.9997 51.9196 23.636 53.7462 24.6057 54.8607C24.9997 55.3251 25.7269 55.6967 26.333 55.7895C27.4542 55.9443 28.4239 55.0465 28.4239 53.901C28.4239 53.158 28.1512 52.7245 27.4239 52.384C26.4542 51.9505 25.3936 52.4459 25.4239 53.4056C25.4239 53.8081 25.6057 54.0558 25.9997 54.2415C26.2421 54.3654 26.2421 54.3654 26.0603 54.3344C25.1815 54.1487 24.9694 53.0341 25.6663 52.322C26.5148 51.4552 28.3027 51.8267 28.9088 53.0341C29.1512 53.5295 29.1815 54.5202 28.9694 55.1394C28.4542 56.5016 26.9997 57.2137 25.5148 56.8112C24.5148 56.5326 24.0906 56.2539 22.8785 54.9846C20.7572 52.7555 19.9391 52.322 16.9088 51.8576L16.333 51.7648L16.9694 51.1456Z",
    fill: "url(#paint6_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03067 1.33127C8.09128 10.0929 18.9701 23.7152 19.5155 24.4582C19.9701 25.0774 19.7882 25.6656 19.0307 26.0991C18.6064 26.3468 17.7276 26.5944 17.3034 26.5944C16.8186 26.5944 16.2428 26.3468 15.8489 25.9443C15.5761 25.6656 14.3943 23.9009 11.7276 19.6594C9.69734 16.4087 7.97007 13.7152 7.93976 13.6842C7.81855 13.6223 7.81855 13.6223 11.5155 20.3715C13.8489 24.613 14.6064 26.13 14.6064 26.3158C14.6064 26.7183 14.4852 26.935 14.0004 27.4923C13.1822 28.4211 12.8186 29.4737 12.5458 31.6718C12.2428 34.1176 11.4246 35.8514 9.09128 38.7926C7.72764 40.5263 7.51552 40.8359 7.18219 41.548C6.75795 42.4149 6.63673 42.9102 6.57613 44.0248C6.51552 45.2012 6.63673 45.9443 6.97007 47.0588C7.2731 48.0495 7.60643 48.6997 8.42461 49.969C9.12158 51.0836 9.54583 51.9195 9.54583 52.2291C9.54583 52.4768 9.60643 52.4768 10.6973 52.2291C13.3034 51.6099 15.4549 50.5573 16.6367 49.257C17.364 48.452 17.5458 48.0186 17.5458 46.904C17.5458 46.192 17.5155 46.0372 17.3337 45.6037C17.0307 44.9226 16.4549 44.3653 15.2125 43.4985C13.5761 42.3529 12.8792 41.4241 12.6973 40.1858C12.5458 39.1331 12.7276 38.4211 13.6367 36.4706C14.5761 34.4582 14.8186 33.6223 14.9701 31.5789C15.061 30.2786 15.2125 29.7523 15.5761 29.3498C15.9701 28.9164 16.3034 28.7616 17.2428 28.6378C18.7882 28.4211 19.7882 28.0186 20.5761 27.2446C21.2731 26.5944 21.5761 25.9443 21.6064 24.9845L21.6367 24.2724L21.2428 23.839C19.8186 22.1672 0.0912804 0 0.000371331 0C-0.0299317 0 0.454917 0.588235 1.03067 1.33127ZM10.3337 45.356C10.667 44.7678 10.4852 44.0248 9.93976 43.6533C9.42461 43.3127 8.63673 43.4675 8.63673 43.9319C8.63673 44.0557 8.69734 44.1796 8.87916 44.2415C9.15189 44.3963 9.18219 44.5511 8.97007 44.8916C8.75795 45.2322 8.75795 45.5418 9.03067 45.7585C9.45492 46.0991 10.0307 45.9133 10.3337 45.356Z",
    fill: "url(#paint7_linear_5110_2670)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6063 29.0713C21.8791 29.288 21.1821 30.093 20.97 30.8979C20.8488 31.3933 20.9094 32.2911 21.1215 32.5697C21.4548 33.0032 21.7579 33.127 22.6063 33.127C24.273 33.127 25.6973 32.384 25.8488 31.4861C26.0003 30.7431 25.3639 29.7214 24.4851 29.257C24.0306 29.0094 23.0912 28.9165 22.6063 29.0713ZM24.5457 30.6193C24.7882 30.2478 24.6973 29.8453 24.2427 29.5666C23.4245 29.0403 22.1821 29.4738 22.1821 30.2787C22.1821 30.6812 22.8185 31.1146 23.4245 31.1146C23.8185 31.1146 24.3639 30.867 24.5457 30.6193Z",
    fill: "url(#paint8_linear_5110_2670)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5110_2670",
    x1: 25.6557,
    y1: 13.4673,
    x2: 37.4792,
    y2: 26.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5110_2670",
    x1: 40.3862,
    y1: 14.3965,
    x2: 46.85,
    y2: 17.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5110_2670",
    x1: 20.7131,
    y1: 14.8916,
    x2: 25.8019,
    y2: 17.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5110_2670",
    x1: 36.8695,
    y1: 26.4707,
    x2: 48.1313,
    y2: 34.4499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5110_2670",
    x1: 26.9428,
    y1: 34.9224,
    x2: 34.5592,
    y2: 41.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5110_2670",
    x1: 41.0499,
    y1: 36.3467,
    x2: 49.6876,
    y2: 39.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5110_2670",
    x1: 21.5042,
    y1: 47.3242,
    x2: 30.4241,
    y2: 58.1615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5110_2670",
    x1: 4.73227,
    y1: -0.00000195566,
    x2: 23.5788,
    y2: 5.08093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5110_2670",
    x1: 21.9938,
    y1: 28.9956,
    x2: 24.8642,
    y2: 31.2474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5110_2670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniswap);
export default __webpack_public_path__ + "static/media/uniswap.d850d55cb0ca231b559371eedacc6ac3.svg";
export { ForwardRef as ReactComponent };